import axios from "../lib/axios";

export const sendSms = async (payload) => {
  try {
    const response = await axios.post("/message/send", payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const getScheduled = async (params = {}) => {
  try {
    const response = await axios.get("/message/scheduled", { params });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch scheduled messages"
    );
  }
};
